import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import FormLabel from '../FormLabel'

const AccessibleFormLabel = ({ formFieldId, label, labelClassName, readOnly, optional, children }) => {
  const [formFieldRef, setFormFieldRef] = useState(null)
  const labelRef = useRef()

  useEffect(() => {
    const { current: labelCurrent } = labelRef

    const focusOnSelect = () => {
      if (!readOnly) formFieldRef.focus()
    }

    labelCurrent.addEventListener('click', focusOnSelect)

    return () => labelCurrent.removeEventListener('click', focusOnSelect)
  })

  return (
    <>
      <FormLabel forwardRef={labelRef} className={labelClassName} id={`${formFieldId}-label`} label={label} optional={optional} />

      {React.Children.map(children, child =>
        React.cloneElement(child, {
          id: formFieldId,
          ariaLabelledby: `${formFieldId}-label`,
          setInnerRef: setFormFieldRef,
        }),
      )}
    </>
  )
}

AccessibleFormLabel.propTypes = {
  formFieldId: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  optional: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default AccessibleFormLabel
